import type { JSX } from 'react';
import { useSafeMode } from '@/lib/safeMode';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { Button } from '@/components/ui/button';
import { HeaderStatusPill } from './HeaderStatusPill';

/**
 * Small indicator in the header when Safe Mode is active.
 * Shows a subtle info pill with tooltip explaining the mode.
 */
export function SafeModeIndicator(): JSX.Element | null {
  const { enabled, autoEnabled, disable } = useSafeMode();

  if (!enabled) {
    return null;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <HeaderStatusPill
          tone="danger"
          icon="info"
          label="Interfaccia semplificata"
          onClick={disable}
          ariaLabel="Interfaccia semplificata attiva - clicca per disattivare"
        />
      </TooltipTrigger>
      <TooltipContent side="bottom" align="end" className="max-w-xs">
        <div className="space-y-2">
          <p className="font-medium">Interfaccia semplificata attiva</p>
          <p className="text-xs text-muted-foreground">
            {autoEnabled
              ? "L'app ha rilevato dei problemi e sta usando temporaneamente controlli semplificati per creare e modificare aziende, stabilimenti e impianti."
              : "L'app sta usando controlli semplificati per creare e modificare aziende, stabilimenti e impianti. Puoi disattivarla in Impostazioni → Supporto."}
          </p>
          <Button size="sm" variant="secondary" className="w-full" onClick={disable}>
            Disattiva
          </Button>
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
